import { render, staticRenderFns } from "./fugaiswipered.vue?vue&type=template&id=952a7d70&scoped=true&"
import script from "./fugaiswipered.vue?vue&type=script&lang=js&"
export * from "./fugaiswipered.vue?vue&type=script&lang=js&"
import style0 from "./fugaiswipered.vue?vue&type=style&index=0&id=952a7d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952a7d70",
  null
  
)

export default component.exports